import 'css-chunk:src/components/widgets/Table/Cell/NameCell.scss';export default {
  "NameCell": "_NameCell_1qxez_1",
  "content": "_content_1qxez_1",
  "avatar": "_avatar_1qxez_8",
  "badge": "_badge_1qxez_16",
  "name": "_name_1qxez_21"
};